import * as React from 'react'
import classNames from 'classnames'

import Link from 'content-components/_Primatives/Link'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

import { Categories } from '..'

type Props = {
  className?: string
} & Categories

CategoryLinks.defaultProps = {
  className: '',
}

function CategoryLinks(props: Props) {
  const { categoryLinks, className, publishedText } = props
  const linkLength = categoryLinks.length

  return (
    <Paragraph className={classNames(style.publishedInfo, className)} small>
      {`${publishedText}: `}
      {categoryLinks.map((link, i) => (
        <Link key={link.text} className={style.link} url={link.url}>
          {`${link.text}${i < linkLength - 1 ? ', ' : ''}`}
        </Link>
      ))}
    </Paragraph>
  )
}

export default CategoryLinks
